import React from 'react';

import cx from 'classnames';
import { useFormContext } from 'react-hook-form';

import TooltipDialog from 'components/Pages/Admin/Itinerary/Details/DetailsChronologicalMode/Event/ModalContents/TooltipDialog';
import Button from 'components/shared/Button';
import { isDefined } from 'utils/ramda';

import cs from '../../../../index.module.css';
import { SaveInfoButton, SaveInfoTooltip } from '../../../shared';
import { TripEventDeafultValuesController } from '../../../types';
import { IAriaTripEventModalContentProps } from '../../types';

type Props = IAriaTripEventModalContentProps & {
  tripEventDeafultValuesController: TripEventDeafultValuesController;
};

function AreaButtonsGroup({ tripEvent, onSubmit, tripEventDeafultValuesController }: Props) {
  const methods = useFormContext();
  const { formState, watch, handleSubmit } = methods;
  const { isSafeInfoDisabled, safeInfoTooltipId, saveInfoSubmitHandler } = tripEventDeafultValuesController;

  const attachedPage = watch('attachedPage');
  const isPageSelected = isDefined(attachedPage);
  const isDisabled = Object.keys(formState.errors).length !== 0 || !isPageSelected;
  const isNeedToShowTooltip =
    tripEvent.id && tripEvent.showChangedRoomOrPageTooltip && tripEvent?.attachedPages?.[0]?.id !== attachedPage?.id;

  return (
    <>
      <div className={cx(cs.footer, cs.improvedUIOnEventModalsFeature)}>
        <SaveInfoButton
          disabled={isSafeInfoDisabled}
          handleSaveForMyself={() => saveInfoSubmitHandler(false)}
          handleSaveForTeam={() => saveInfoSubmitHandler(true)}
          tooltipId={safeInfoTooltipId}
        />

        <div className={cs.rightFooter}>
          {tripEvent.id && (
            <TooltipDialog tripEventId={tripEvent.id} onSubmit={() => {}}>
              <Button type="primary2" className={cs.buttonText} size="large" htmlType="button">
                Remove
              </Button>
            </TooltipDialog>
          )}

          {isNeedToShowTooltip ? (
            <TooltipDialog
              onSubmit={handleSubmit(onSubmit)}
              text={'Updating the Content Page here will overwrite \n the changes you had made within the itinerary.'}
              cancelButtonText="Cancel"
              confirmButtonText="Confirm"
            >
              <Button disabled={isDisabled} className={cs.buttonText} size="large" htmlType="button">
                Update
              </Button>
            </TooltipDialog>
          ) : (
            <Button
              disabled={isDisabled}
              className={cs.buttonText}
              onClick={handleSubmit(onSubmit)}
              size="large"
              htmlType="button"
            >
              {tripEvent.id ? 'Update' : 'Add'}
            </Button>
          )}
        </div>
      </div>

      <SaveInfoTooltip tooltipId={safeInfoTooltipId} />
    </>
  );
}

export { AreaButtonsGroup };
